export const escHtml = (s) =>
  s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;")

const darken = (hex, amount = 0.2) => {
  const n = parseInt(hex.replace("#", ""), 16)
  const r = Math.max(0, Math.round(((n >> 16) & 0xff) * (1 - amount)))
  const g = Math.max(0, Math.round(((n >> 8) & 0xff) * (1 - amount)))
  const b = Math.max(0, Math.round((n & 0xff) * (1 - amount)))
  return `#${((r << 16) | (g << 8) | b).toString(16).padStart(6, "0")}`
}

const markerStyle = (fillColor, isWinner) => ({
  radius: isWinner ? 12 : 8,
  fillColor,
  color: darken(fillColor, 0.25),
  weight: isWinner ? 3 : 2,
  fillOpacity: isWinner ? 0.9 : 0.8,
})

export const markerPopup = (name, waitMinutes) => {
  const safe = escHtml(name)
  if (!waitMinutes) return `<strong>${safe}</strong>`
  return `<strong>${safe}</strong><br>${waitMinutes} min wait`
}

const USER_MARKER_STYLE = {
  radius: 5,
  fillColor: "#3498db",
  color: "#2980b9",
  weight: 2,
  fillOpacity: 0.9,
}

export const addUserMarker = (L, map, coords) =>
  L.circleMarker([coords.latitude, coords.longitude], USER_MARKER_STYLE).addTo(map).bindPopup("You")

export const initMap = (L, container) => {
  const map = L.map(container)
  L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
    maxZoom: 19,
  }).addTo(map)
  return map
}

const labeledIcon = (L, color, label, isWinner) => {
  const size = isWinner ? 28 : 22
  const border = darken(color, 0.25)
  const weight = isWinner ? 3 : 2
  const font = isWinner ? 13 : 11
  const opacity = isWinner ? 0.95 : 0.85
  return L.divIcon({
    className: "",
    html: `<div style="width:${size}px;height:${size}px;border-radius:50%;background:${color};border:${weight}px solid ${border};color:#fff;font:700 ${font}px sans-serif;display:flex;align-items:center;justify-content:center;opacity:${opacity}">${label}</div>`,
    iconSize: [size, size],
    iconAnchor: [size / 2, size / 2],
  })
}

export const createMapMarkers = (L, map, items, { colorFn, winnerName, labelFn, popupFn }) =>
  items
    .map((item, i) => {
      if (!item.lat || !item.lng) return null
      const isWinner = winnerName && item.name === winnerName
      const color = colorFn(item, i)
      const marker = labelFn
        ? L.marker([item.lat, item.lng], { icon: labeledIcon(L, color, labelFn(item, i), isWinner) })
        : L.circleMarker([item.lat, item.lng], markerStyle(color, isWinner))
      const popup = popupFn ? popupFn(item, i) : markerPopup(item.name, item.wait_minutes)
      marker.addTo(map).bindPopup(popup)
      if (isWinner) marker.openPopup()
      return marker
    })
    .filter(Boolean)
